import { create } from 'zustand'
import createSelectors from '../utils/createSelectors'

interface State {
  facets: any
  dropdownFacets: any
  startDate: Date | null
  endDate: Date | null
  storeFilteredItems: number
  storeItemsToShow: number
  modalOpen: boolean
  search: string
  sortBy:
    | 'random'
    | 'name-asc'
    | 'name-desc'
    | 'price-asc'
    | 'price-desc'
    | 'date-asc'
    | 'date-desc'
    | 'distance-asc'
    | 'distance-desc'
    | 'difficulty-asc'
    | 'difficulty-desc'
    | 'duration-asc'
    | 'duration-desc'
    | null
  isReady: boolean
  isOpenToday: boolean
}
interface Action {
  setFacets: (facets: State['facets']) => void
  setIsOpenToday: (openToday: State['isOpenToday']) => void
  setIsReady: (isReady: State['isReady']) => void
  setDropdownFacets: (dropdownFacets: State['dropdownFacets']) => void
  setStoreFilteredItems: (
    storeFilteredItems: State['storeFilteredItems']
  ) => void
  setSearch: (search: State['search']) => void
  setStoreItemsToShow: (storeItemsToShow: State['storeItemsToShow']) => void
  setStartDate: (startDate: State['startDate']) => void
  setEndDate: (endDate: State['endDate']) => void
  setModalOpen: (modalOpen: State['modalOpen']) => void
  setSortBy: (sortBy: State['sortBy']) => void
  reset: () => void
}

const baseStoreNature = create<State & Action>((set) => ({
  facets: [],
  isReady: false,
  dropdownFacets: [],
  startDate: null,
  endDate: null,
  storeFilteredItems: 0,
  storeItemsToShow: 0,
  modalOpen: false,
  search: '',
  sortBy: null,
  isOpenToday: false,
  setIsReady: (isReady) => set(() => ({ isReady })),
  setSortBy: (sortBy) => set(() => ({ sortBy })),
  setStartDate: (startDate) => set(() => ({ startDate })),
  setEndDate: (endDate) => set(() => ({ endDate })),
  setStoreFilteredItems: (storeFilteredItems) =>
    set(() => ({ storeFilteredItems })),
  setStoreItemsToShow: (storeItemsToShow) => set(() => ({ storeItemsToShow })),
  setFacets: (facets) => set(() => ({ facets })),
  setDropdownFacets: (dropdownFacets) => set(() => ({ dropdownFacets })),
  setModalOpen: (modalOpen) => set(() => ({ modalOpen })),
  setSearch: (search) => set(() => ({ search })),
  setIsOpenToday: (openToday) => set(() => ({ isOpenToday: openToday })),
  reset: () =>
    set({
      facets: [],
      // storeFilteredItems: 0,
      // storeItemsToShow: 0,
      startDate: null,
      endDate: null,
      search: '',
      sortBy: null,
      dropdownFacets: []
    })
}))

const useStoreNature = createSelectors(baseStoreNature)

export default useStoreNature
